import { AxiosError } from 'axios';
import { UseQueryOptions, useQuery } from 'react-query';
import { client } from '../util/client';
import { GetInvitationResponse } from '@aldebaran/common/types/api';

export const useInvitation = (
  id: string,
  options: UseQueryOptions<GetInvitationResponse, AxiosError> = {},
) => {
  return useQuery<GetInvitationResponse, AxiosError>(
    ['invitation', id],
    async () => client(`/invitation/${id}`).then((response) => response?.data),
    {
      enabled: !!id,
      retry: false,
      ...options,
    },
  );
};
